function GetHashParamValueSW(param) {

    //alert("indexof:" + window.location.hash.indexOf("&" + param + "="));

    if (window.location.hash.indexOf("&" + param + "=") == -1 && window.location.hash.indexOf("#" + param + "=")) {
        return "";
    }
    var value = "";

    for (var i = 1; i <= 2; i++) {

        var key = "&";

        if (i == 2) key = "#";

        if (window.location.hash.indexOf(key + param + "=") != -1) {

            var nmVL = window.location.hash.split(key + param + "=");

            if (nmVL != undefined && nmVL.length >= 2) {


                if (nmVL[1].indexOf("&") != -1) {
                    value = nmVL[1].split("&")[0];
                }

                else {
                    value = nmVL[1];
                }
            }
        }

    }

    return value;


}


function ChangeSwHashedStringParamValue(params, removedParam, newValue) {


    if (params != undefined && params.length > 0) {

        var splitStr = (removedParam + "=");
        var newParamsArray = params.split(splitStr);

        if (newParamsArray.length >= 2) {
            var firstPartOfParams = newParamsArray[0];
            var secondPartOfParams = "";
            var beginCalc = false;
            for (var i = 0; i < newParamsArray[1].length; i++) {

                if (beginCalc) {
                    secondPartOfParams += newParamsArray[1][i];
                }

                if (newParamsArray[1][i] == "&") {
                    beginCalc = true;
                }


            }

            params = firstPartOfParams + removedParam + "=" + newValue + "&" + secondPartOfParams;

        }

    }

    return params;

}

function AddSwParam(params, paramName, paramValue) {

    params += "&"+paramName + "=" + paramValue;

    return params;

}
